import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="font-western text-6xl text-gold mb-4">404</h1>
        <h2 className="font-western text-2xl text-cream mb-4">Lost in the Desert</h2>
        <p className="text-text-secondary mb-8">
          The page you're looking for has wandered off into the wilderness.
        </p>
        <Link to="/" className="btn-primary">
          Return to Oasis
        </Link>
      </div>
    </div>
  );
}
